// Normaliza roles a una lista de strings (por ejemplo: ["ADMIN", "KUNAK", "USER"])
const normalizeRoles = (roles) =>
  roles.map(r => (typeof r === 'string' ? r : r.name));

export const permissions = {
  // KUNAK
  isKunak: (roles) => {
    const r = normalizeRoles(roles);
    return ["KUNAK"].some(role => r.includes(role));
  },
  // USERS
  canViewUsers: (roles) => {
    const r = normalizeRoles(roles);
    return ["ADMIN", "KUNAK", "USERS_ADMIN"].some(role => r.includes(role));
  },
  canCreateUsers: (roles) => {
    const r = normalizeRoles(roles);
    return ["ADMIN", "KUNAK", "USERS_ADMIN"].some(role => r.includes(role));
  },
  canEditUsers: () => true, // cualquier autenticado según tu backend
  canDeleteUsers: (roles) => {
    const r = normalizeRoles(roles);
    return ["ADMIN", "KUNAK", "USERS_ADMIN"].some(role => r.includes(role));
  },

  // COMPLAINTS
  canViewComplaints: (roles) => {
    const r = normalizeRoles(roles);
    return ["ADMIN", "KUNAK", "COMPLAINTS_ADMIN", "COMPLAINTS_VIEW"].some(role => r.includes(role));
  },
  canPostComplaints: (roles) => {
    const r = normalizeRoles(roles);
    return ["ADMIN", "KUNAK", "USER", "COMPLAINTS_ADMIN"].some(role => r.includes(role));
  },
  canEditComplaints: (roles) => permissions.canPostComplaints(roles),
  canDeleteComplaints: (roles) => permissions.canPostComplaints(roles),
  
  // INCIDENTS
  canViewIncidents: (roles) => {
    const r = normalizeRoles(roles);
    return ["ADMIN", "KUNAK", "INCIDENTS_ADMIN", "INCIDENTS_VIEW"].some(role => r.includes(role));
  },
  canPostIncidents: (roles) => {
    const r = normalizeRoles(roles);
    return ["ADMIN", "KUNAK", "USER", "INCIDENTS_ADMIN"].some(role => r.includes(role));
  },
  canEditIncidents: (roles) => permissions.canPostIncidents(roles),
  canDeleteIncidents: (roles) => permissions.canPostIncidents(roles),

  // DEVICES
  canViewDevices: () => true, // abierto a todos
  canManageDevices: (roles) => {
    const r = normalizeRoles(roles);
    return ["KUNAK", "DEVICES_ADMIN"].some(role => r.includes(role));
  },

  // EMISSION POINTS
  canViewEmissionPoints: () => true, // abierto a todos
  canManageEmissionPoints: (roles) => {
    const r = normalizeRoles(roles);
    return ["KUNAK", "EMISSION_POINTS_ADMIN"].some(role => r.includes(role));
  },

  // ROLES
  canViewRoles: (roles) => {
    const r = normalizeRoles(roles);
    return ["ADMIN", "KUNAK", "USERS_ADMIN"].some(role => r.includes(role));
  },

  // HISTORICAL (lecturas/mapa/wind-graphs)
  canViewHistorical: (roles) => {
    const r = normalizeRoles(roles);
    return ["ADMIN", "KUNAK", "USER"].some(role => r.includes(role));
  },

  // Vistas específicas (como en topbar)
  canAccessHistoricalTab: (roles) => {
    const r = normalizeRoles(roles);
    const restricted = ["COMPLAINTS_VIEW", "COMPLAINTS_ADMIN", "INCIDENTS_VIEW", "INCIDENTS_ADMIN"];
    return r.some(role => !restricted.includes(role));
  },
  
  canViewSidebar: (roles) => {
    const r = normalizeRoles(roles);
    const restricted = ["COMPLAINTS_VIEW", "COMPLAINTS_ADMIN", "INCIDENTS_VIEW", "INCIDENTS_ADMIN"];
    return r.some(role => !restricted.includes(role));
  },

  // Esconder vistas si no tiene permisos
  isComplaintView: (roles) => {
    const r = normalizeRoles(roles);
    const allowed = ["COMPLAINTS_VIEW", "COMPLAINTS_ADMIN"];
    return r.length > 0 && r.every(role => allowed.includes(role));
  },

  isIncidentView: (roles) => {
    const r = normalizeRoles(roles);
    const allowed = ["INCIDENTS_VIEW", "INCIDENTS_ADMIN"];
    return r.length > 0 && r.every(role => allowed.includes(role));
  }
};
